<template lang="pug">
  .column
    .content.has-text-centered
      i.fa.fa-spinner.fa-spin(style="font-size:48px")
</template>

<script>
  export default {
    name: 'Loader'
  }
</script>


<style lang="scss" scoped>
  .content {
    padding: 40px;
    min-height: 40vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/LoaderTb.vue